
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/my-orders-returns",
      function () {
        return require("private-next-pages/account/my-orders-returns/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/my-orders-returns"])
      });
    }
  